"use strict";
export const OPENOCEAN_API_BASE = process.env.REACT_APP_OPENOCEAN_PROXY || "https://www.topazdex.com/api/openocean";
export const OPENOCEAN_ORDERS_BASE = process.env.REACT_APP_OPENOCEAN_ORDERS_PROXY || "https://open-api.openocean.finance";
export const OPENOCEAN_NATIVE_TOKEN = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
export const OPENOCEAN_CHAIN_PATH = {
  56: "bsc"
};
export const OPENOCEAN_ORDER_CHAIN_ID = 56;
export const OPENOCEAN_V4_ROUTER = "0x6352a56caadC4F1E25CD6c75970Fa768A3304e64";
export const OPENOCEAN_LIMIT_ORDER_CONTRACT = "0xA8A0213bb2ce671E457Ec14D08EB9d40E6DA8e2d";
export const OPENOCEAN_DCA_CONTRACT = "0x6cBB2598881940D08d5Ea3fA8F557E02996e1031";
export const OPENOCEAN_ORDER_REFERRER = "0xF407739E81574A3C9A3195bCb85eE694C94e540c";
export const OPENOCEAN_ORDER_REFERRER_FEE = 0;
export const OPENOCEAN_MIN_SLIPPAGE_PERCENT = 0.05;
export const OPENOCEAN_MAX_SLIPPAGE_PERCENT = 50;
export const OPENOCEAN_OUTPUT_BUFFER_BPS = 70;
export const OPENOCEAN_BPS_DENOMINATOR = 10000n;
export const OPENOCEAN_ROUTE_RANKING_PENALTY_BPS = 100;
export function applyOpenOceanRankingPenalty(amount) {
  const multiplier = OPENOCEAN_BPS_DENOMINATOR - BigInt(OPENOCEAN_ROUTE_RANKING_PENALTY_BPS);
  return amount * multiplier / OPENOCEAN_BPS_DENOMINATOR;
}
export const OPENOCEAN_DEFAULT_GAS_PRICE_WEI = "1000000000";
export function getOpenOceanChainPath(chainId) {
  return chainId === void 0 ? void 0 : OPENOCEAN_CHAIN_PATH[chainId];
}
export function clampOpenOceanSlippage(slippagePercent) {
  return Math.min(
    OPENOCEAN_MAX_SLIPPAGE_PERCENT,
    Math.max(OPENOCEAN_MIN_SLIPPAGE_PERCENT, slippagePercent)
  );
}
export function getOpenOceanRequestSlippage(slippagePercent) {
  return clampOpenOceanSlippage(slippagePercent + OPENOCEAN_OUTPUT_BUFFER_BPS / 100);
}
export function applyOpenOceanOutputBuffer(rawAmount) {
  const parsed = BigInt(rawAmount);
  const multiplier = OPENOCEAN_BPS_DENOMINATOR - BigInt(OPENOCEAN_OUTPUT_BUFFER_BPS);
  return (parsed * multiplier / OPENOCEAN_BPS_DENOMINATOR).toString();
}
